export interface FcfDeepLinkParams {
  cancellationId: string;
  qualification: string;
  shiftStart: string;
  cancelledWorkplaceId: string;
}

export const FCF_DEEP_LINK_PARAM_KEYS = {
  cancellationId: "fcfCancellationId",
  qualification: "fcfQualification",
  shiftStart: "fcfShiftStart",
  cancelledWorkplaceId: "fcfCancelledWorkplaceId",
} as const;

export type FcfModalSource = "deep_link" | "auto_trigger";
export type FcfDismissMethod = "not_interested_tap" | "close_button_tap" | "app_closed";

export const MAX_FCF_REPLACEMENT_SHIFTS = 5;

export const FCF_SHIFT_RECOMMENDATIONS_DEFAULT_CONFIG = {
  enabled: false,
  leadTimeWindowMinutes: 60,
  distanceMiles: 30,
  startProximityMinutes: 30,
} as const;
